import { createReducer } from 'redux-act';

import { setCookieConsent, setRememberMe } from './actions';

export const defaultCookieConsentState: WebOrder.State.CookieConsent = {
  selectedGroups: [],
  rememberMe: false,
};

const cookieConsentReducer = createReducer({}, defaultCookieConsentState);
export { cookieConsentReducer };

cookieConsentReducer.on(setCookieConsent, (state, payload) => ({
  ...state,
  selectedGroups: payload,
}));

cookieConsentReducer.on(setRememberMe, (state, payload) => ({
  ...state,
  rememberMe: payload,
}));
